import { __read, __spread } from "tslib";
var Performance = /** @class */ (function () {
    function Performance() {
        this._performance = window.performance;
    }
    Performance.prototype.clearMarks = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._performance || !this._performance.clearMarks)
            return;
        (_a = this._performance).clearMarks.apply(_a, __spread(args));
    };
    Performance.prototype.mark = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._performance || !this._performance.mark)
            return;
        (_a = this._performance).mark.apply(_a, __spread(args));
    };
    Performance.prototype.getEntriesByName = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._performance || !this._performance.getEntriesByName)
            return [];
        return (_a = this._performance).getEntriesByName.apply(_a, __spread(args));
    };
    Performance.prototype.getTimeOrigin = function () {
        if (!this._performance ||
            (!this._performance.timeOrigin && !this._performance.timing))
            return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    };
    Performance.prototype.now = function () {
        if (!this._performance || !this._performance.now) {
            return Date.now ? Date.now() : +(new Date());
        }
        return this._performance.now();
    };
    Performance.prototype.isAvailable = function () {
        return !!this._performance &&
            !!this._performance.clearMarks &&
            !!this._performance.mark &&
            !!this._performance.getEntriesByName &&
            !!this._performance.timing;
    };
    return Performance;
}());
export default Performance;
